import React, { useEffect, useState, useRef } from "react";
import confetti from "canvas-confetti";
import { useNavigate } from "react-router-dom";
import BottomNavigation from "../components/BottomNavigation";
import { getRuletaData, registrarIntentoRuleta } from "../api";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import { motion, AnimatePresence } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Ruleta = () => {
  const navigate = useNavigate();
  const [animacionTerminada, setAnimacionTerminada] = useState(false);
  const [historial, setHistorial] = useState([]);
  const [comercios, setComercios] = useState([]);
  const [userId, setUserId] = useState(null);
  const ultimaSeleccion = useRef(null);
  
  const ruletaInicializada = useRef(false);
  const [loading, setLoading] = useState(true);
  const showSplash = useDynamicSplash(loading);
  const { user, authReady } = useAuth();
  const slicesRef = useRef([]);
  const [comercioGanador, setComercioGanador] = useState(null);

  useEffect(() => {
    if (!authReady) return;
    if (!user?.id) {
      navigate("/login", { replace: true });
    }
  }, [authReady, user]);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (!userData?.id) return;
    setUserId(userData.id);

    const cargarDatos = async () => {
      setLoading(true);
      document.body.style.overflow = "hidden";
      try {
        const data = await getRuletaData(userData.id);
        if (data) {
          setComercios(data.comercios || []);
          setHistorial(
            (data.historial || []).map(h => ({
              nombre: h.nombre,
              imagen: h.logo,
              id_sucursal: h.id_sucursal,
              fecha: new Date(h.fecha).toLocaleDateString("es-GT")
            }))
          );
        }
      } finally {
        setLoading(false);
        document.body.style.overflow = "auto";
        window.scrollTo(0, 0);
      }
    };
    cargarDatos();
  }, []);

  useEffect(() => {
    const $ = window.$ || window.jQuery;
    if (!$.fn.superWheel || $(".wheel").length === 0 || comercios.length === 0) return;

    const slices = comercios.map((comercio, index) => ({
      text: comercio.nombre,
      message: comercio.nombre,
      background: "#" + Math.floor(Math.random() * 16777215).toString(16),
      value: (index + 1) * 100,
      id_comercio: comercio.id_comercio,
      logo: comercio.logo,
      id_sucursal: comercio.id_sucursal
    }));

    slicesRef.current = slices;

    function getRandomIndexExcludingPrevious(length) {
      let index;
      do {
        index = Math.floor(Math.random() * length);
      } while (index === ultimaSeleccion.current && length > 1);
      ultimaSeleccion.current = index;
      return index;
    }

    function lanzarConfetti() {
      var duration = 10000;
      var end = Date.now() + duration;
      (function frame() {
        confetti({ particleCount: 5, spread: 100, origin: { y: 0.6 } });
        if (Date.now() < end) requestAnimationFrame(frame);
      })();
    }

    if (!ruletaInicializada.current && slices.length > 0) {
      ruletaInicializada.current = true;

      $(".wheel").superWheel({
        slices,
        text: {
          color: "#fff",
          offset: 8,
          letterSpacing: 0,
          orientation: "v",
          arc: true,
        },
        slice: {
          background: "#333",
        },
        line: {
          width: 3,
          color: "#fff",
        },
        outer: {
          width: 8,
          color: "#eaeaea",
        },
        inner: {
          width: 8,
          color: "#eaeaea",
        },
        center: {
          width: 5,
          rotate: true,
        },
        marker: {
          background: "#f39c12",
          animate: true,
        },
        rotates: 50,
        duration: 8000,
      });

      $(".wheel").superWheel("onStart", function () {
        $(".spin-to-win").text("Girando, espera...");
      });

      $(".wheel").superWheel("onStep", function () {

      });

      $(".wheel").superWheel("onComplete", async function (ganador) {
        if (!ganador) return;

        setComercioGanador(ganador); 

        $("#confettiOverlay").fadeIn(300);
        $("#winnerLogo").attr("src", ganador.logo);
        $("#winnerName").html(`
          ${ganador.message || ganador.text}
          <img src="/assets/images/verified.svg" class="verifiedUser" alt="Verificado" />
        `);
        $("#winnerContainer").fadeIn(500);

        const fecha = new Date().toLocaleDateString("es-GT");
        setHistorial((prev) => [
          { nombre: ganador.message || ganador.text, imagen: ganador.logo, fecha },
          ...prev
        ]);

        if (userId && ganador.id_comercio) {
          await registrarIntentoRuleta({ id_perfil: userId, id_comercio: ganador.id_comercio });
        }

        lanzarConfetti();

        setTimeout(() => {
          $("#winnerContainer").fadeOut(500);
          $("#confettiOverlay").fadeOut(500);
          $(".spin-to-win:disabled").prop("disabled", false).text("Gira para elegir");
        }, 10000);
      });
    }

    // Registrar el botón siempre
    $(".spin-to-win").off("click").on("click", function (e) {
      e.preventDefault();
      if (comercios.length === 0) return;

      const index = getRandomIndexExcludingPrevious(comercios.length);
      const slice = slicesRef.current[index];
      $(".wheel").superWheel("start", "value", slice.value);
      $(this).prop("disabled", true);
    });
  }, [comercios, userId, animacionTerminada]);

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      <div className="container-fluid">
        {!showSplash && (
          <>
            <motion.div
              initial={{ y: "100%", opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: "100%", opacity: 0 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
              onAnimationComplete={() => setAnimacionTerminada(true)} 
            >
              <div className="roulette-container">
                <h3>Gira y decide</h3>
                <p>Si aún no decides que comer hoy, deja que elijamos por ti, presiona en <b>GIRA PARA ELEGIR</b> y te daremos una opción de alimentación. 🥰</p>
                <div id="confettiOverlay"></div>
                <div id="winnerContainer">
                  <img id="winnerLogo" src="" onClick={() => {
                      if (comercioGanador?.id_sucursal) {
                        navigate(`/comercio/app/${comercioGanador.id_sucursal}`);
                      }
                    }} alt="Logo del ganador" />
                  <p id="winnerName"></p>
                  <p id="winnerProfile">
                    <a onClick={() => {
                      if (comercioGanador?.id_sucursal) {
                        navigate(`/comercio/app/${comercioGanador.id_sucursal}`);
                      }
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16">
                        <path fill="currentColor" fillRule="evenodd" d="M1.25 8A.75.75 0 0 1 2 7.25h10.19L9.47 4.53a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H2A.75.75 0 0 1 1.25 8" clipRule="evenodd" strokeWidth="0.7" stroke="currentColor" />
                      </svg>
                      Ir al perfil
                    </a>
                  </p>
                </div>
                <div className="ruleta-container">
                  <button className="spin-to-win" type="button">Gira para elegir</button>
                  <div className="wheel"></div>
                </div>
                <div className="premios-container">
                  <h2 className="premios-titulo">Tu historial</h2>
                  <div className="premios-grid">
                    {historial.length > 0 ? (
                      historial.map((item, index) => (
                        <div className="premio-item" key={index} onClick={() => navigate(`/comercio/app/${item.id_sucursal}`)}>
                          <div className="premio-circulo">
                            <img src={item.imagen} alt={item.nombre} />
                          </div>
                          <p className="premio-texto">
                            {item.nombre} <img src="/assets/images/verified.svg" className="verifiedUser" style={{ width: 300, marginLeft: 0 }} alt="Verificado" /> <small>{item.fecha}</small>
                          </p>
                        </div>
                      ))
                    ) : (
                      <div style={{ marginBottom: 70, marginTop: 20, paddingRight: 15, paddingLeft: 15 }}>
                        <img src="/assets/images/empty.svg" style={{ width: 135, paddingBottom: 10 }} alt="Sin historial" />
                        <p>Aquí verás tu historial en cuanto empieces a girar.</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </motion.div>
            <BottomNavigation /> {/* ✅ Fuera del motion */}
          </>
        )}
      </div>
    </>
  );
  
};

export default Ruleta;
